import { atomFamily } from 'recoil'

export const activityStreamState = atomFamily({
  key: 'activityStreamState',
  default: {
    items: [],
    pageNumber: 1,
    pageSize: 10,
    activityEventTypes: [],
    totalItems: 0,
    loading: false,
    error: false,
    loaded: false,
    //
    idTask: undefined,
    pollingIteration: 0,
  },
})
